<div class="container-fluid break_pages" style="background-color:white;color:black" *ngIf="withdrawal">
	<div class="text-center">
		<img [src]="rest.getImagePath(store?.ticket_image_id, rest.local_preferences.default_ticket_image_id)" style="width:50%;max-width:700;padding-bottom:50px">
	</div>
	<div class="px-3">
		<div *ngIf="withdrawal" class="text-center fw-bold pb-3">
			<div *ngIf="store?.business_name" class="fw-bold">{{store.business_name}}</div>
			<div *ngIf="store?.rfc">{{store.rfc}}</div>
			<span>{{store?.name}}</span>
			<span *ngIf="store?.address">{{store.address}}</span>
			<span *ngIf="store?.city">,{{store.city | titlecase}}</span>
			<span *ngIf="store?.phone">{{store.phone}}</span>
		</div>

		<h3>Recibo de Retiro Folio #{{withdrawal.id}}</h3>
		<div class="mt-3">Fecha: <span class="fw-bold">#{{withdrawal?.created | shortDate:'full'}}</span></div>
		<div class="pb-3">Atendio:<span class="fw-bold">{{user?.name}}</span></div>
		<div class="pb-3">Monto Retirado:
			<span class="fw-bold">{{withdrawal?.amount}} {{withdrawal.currency_id}}</span>
		</div>
		<div class="pb-3" *ngIf="withdrawal?.note">Concepto:<span class="fw-bold">{{withdrawal?.note}}</span></div>
	</div>
	<div class="px-3">
		El retiro por la cantidad de: <span class="fw-bold">${{withdrawal?.amount}}</span>
		Solo es valido cuando presenta la firma del Gerente
		<br>
	</div>
	<div class="px-3 mb-3 mt-3 fw-bold">Recibio:</div>
	<div class="px-3 border-bottom my-3 py-3">&nbsp;</div>
	<div class="px-3 my-3 py-3">&nbsp;</div>
</div>